module.exports = __webpack_public_path__ + "img/NewspaperColor.9ffff045.png";